import { createSlice } from '@reduxjs/toolkit';
import api from '../Components/_helpers/api';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    data: { data: [] },
    currentFilters: {},
    isLoading: true,
    error: '',
  },
  reducers: {
    requestUser: (state, action) => {
      state.isLoading = true;
      state.currentFilters = action.payload;
      state.error = '';
    },
    requestUserSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    requestUserFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { requestUser, requestUserSuccess, requestUserFailure, setError } = userSlice.actions;

//Thunks
export const RequestUsersAsync = (payload) => (dispatch) => {
  let filters = payload || {};
  dispatch(requestUser(filters));

  api
    .post('/User/GetAllUsers', payload)
    .then((data) => {
      dispatch(requestUserSuccess(data.data));
    })
    .catch((e) => {
      console.log(e);
      dispatch(requestUserFailure(e));
    });
};

export const SaveUserAsync = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api
      .post('/User', { ...payload })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const UpdateUserAsync = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api
      .put('/User', { ...payload })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const DeleteUserAsync = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api
      .delete(`/User?userId=${payload}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

//Selector
export const selectData = (state) => state.user.data;
export const selectIsLoading = (state) => state.user.isLoading;
export const selectError = (state) => state.user.error;
export const selectCurrentFilters = (state) => state.user.currentFilters;

export default userSlice.reducer;
